"use strict"

import React from "react"

import { fillColors } from "./index"
import {
  action_detail_overlay,
  getFormattedMessage,
} from "../../../../../components/shared_components_registration"

export default function ActionDetailOverlay({ timeExtractor, events, selected_timezone }) {
  return (
    <div className="action-detail-content">
      {events.map((ev, idx) => {
        let backgroundStyle = {}
        const annotation = !!ev["user_id"]
        const site_action = !!ev["filetype"]
        // Alter background color to make finding 'special' actions easier
        if (annotation) {
          backgroundStyle =
            ev["tags"].length === 0
              ? { backgroundColor: fillColors["not_tag_specific_ano"] }
              : { backgroundColor: fillColors["tag_specific_ano"] }
        } else if (site_action) {
          backgroundStyle = { backgroundColor: fillColors["site_action"] }
        } else if (ev?.priority === "CRIT") {
          backgroundStyle = { backgroundColor: fillColors["run_action_critical"] }
        }
        return (
          <div key={idx}>
            <div style={{ fontStyle: "italic", fontSize: "12px" }}>
              <span style={backgroundStyle}>
                {action_detail_overlay["get_time_and_operator"](
                  ev,
                  timeExtractor,
                  selected_timezone,
                  annotation,
                )}
              </span>
            </div>
            {ev?.name && (
              <div style={{ paddingLeft: "0.8em", paddingTop: "0" }}>
                <u>{`${ev.name} [${ev.reactor}]`}</u>
              </div>
            )}
            <div style={{ paddingLeft: "0.8em", paddingTop: "0" }}>
              {[
                [ev.filetype, getFormattedMessage("", "FileType")], // No current LTPM use so no translation id
                [ev.priority, getFormattedMessage("general.priority", "Priority")],
                [ev.action, getFormattedMessage("general.action", "Action")],
                [ev.comment, getFormattedMessage("general.comment", "Comment")],
              ].map(
                (info, idx) =>
                  info[0] && (
                    <div key={idx}>
                      {info[1]}: &nbsp;
                      {info[0]}
                    </div>
                  ),
              )}
              {annotation && ev.tags && ev.tags.length > 0 && (
                <div style={{ overflowWrap: "break-word", maxWidth: "250px" }}>
                  {/* No current LTPM use so no translation id */}
                  {getFormattedMessage("", "Annotated Tags")}: &nbsp;
                  {ev.tags.join(", ")}
                </div>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
